import React from 'react';
import WorkItemRenderer from './WorkItemRenderer';

export default function InterviewBody(): React.ReactElement {
  return <WorkItemRenderer />;
}
